<template>
	<core-button
		:color="color"
		:size="size"
		v-bind="$attrs"
		v-on="$listeners"
		routerTo="onboarding-wizard"
	>
		<slot>Create a Free Account</slot>
	</core-button>
</template>
<script lang="js">

export default  {
	inheritAttrs : false,
	props        : {
		color : {
			type    : String,
			default : 'blue',
		},
		size : {
			type    : String,
			default : 'medium',
		},
	},
}
</script>
